import { stage, trackWithDefaultStage } from "@flights/et-universal";
import { isOfMetaOrigin, isOfPPCOrigin } from "../utils/marketing-url-params";
import useGlobalContext from "./useGlobalContext";
import useUserAgent from "./useUserAgent";

const WINTER_DEALS_EXCLUDED_COUNTRIES = ["gb", "id", "qa"];

export const useWinterDeals = () => {
  const { ipCountry = "" } = useGlobalContext();
  const { isMobile } = useUserAgent();

  const isWinterDealsEligible =
    !WINTER_DEALS_EXCLUDED_COUNTRIES.includes(ipCountry?.toLowerCase() || "") && !isOfMetaOrigin() && !isOfPPCOrigin();

  const isWinterDealsExp =
    isWinterDealsEligible && !!trackWithDefaultStage("flights_web_cat_winter_deals_promo_2026", 1);

  if (isWinterDealsEligible) {
    stage("flights_web_cat_winter_deals_promo_2026", isMobile ? 3 : 2);
  }

  return { isWinterDealsEligible, isWinterDealsExp };
};
